import React from 'react';
import { Box, Heading, CloseButton } from '@chakra-ui/react';

interface SimpleModalProps {
    isOpen: boolean;
    onClose: () => void;
    title?: React.ReactNode;
    footer?: React.ReactNode;
    size?: 'sm' | 'md' | 'lg';
    closeOnOverlayClick?: boolean;
    showCloseButton?: boolean;
    children: React.ReactNode;
}

const sizeMap: Record<NonNullable<SimpleModalProps['size']>, string> = {
    sm: '400px',
    md: '600px',
    lg: '800px',
};

const SimpleModal: React.FC<SimpleModalProps> = ({
    isOpen,
    onClose,
    title,
    footer,
    size = 'md',
    closeOnOverlayClick = true,
    showCloseButton = true,
    children,
}) => {
    if (!isOpen) return null;

    const handleOverlayClick = () => {
        if (closeOnOverlayClick) {
            onClose();
        }
    };

    return (
        <Box position="fixed" inset={0} zIndex={1400}>
            <Box position="absolute" inset={0} bg="blackAlpha.600" onClick={handleOverlayClick} />
            <Box
                position="relative"
                maxW={sizeMap[size]}
                w="90%"
                mx="auto"
                mt="10vh"
                bg="white"
                borderRadius="lg"
                boxShadow="2xl"
                overflow="hidden"
            >
                {title && (
                    <Box display="flex" alignItems="center" justifyContent="space-between" px={6} py={4} borderBottom="1px solid" borderColor="gray.100">
                        {typeof title === 'string' ? <Heading size="md">{title}</Heading> : title}
                        {showCloseButton && (
                            <CloseButton onClick={onClose} />
                        )}
                    </Box>
                )}
                <Box px={6} py={4} maxH="70vh" overflowY="auto">
                    {children}
                </Box>
                {footer && (
                    <Box borderTop="1px solid" borderColor="gray.100" px={6} py={4}>
                        {footer}
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default SimpleModal;
